// Auth context lives in its own module so pages and components can consume it
// without importing App.js (which imports every page: that was 9 import cycles).
// App.js re-exports both names for backwards compatibility.
import { createContext, useContext } from "react";

export const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);
